/** creates a string enum
 * @example Runtime & Compile time:
 * export const FRUIT = createEnum('apple', 'banana');
 * export type FRUIT = createEnum<typeof Fruit>>;
 * @example Compile-time only:
 * export type FRUIT = createEnum<'apple' | 'banana'> which is an alias for
 * export type FRUIT = 'apple' | 'banana'
 * */
export function createEnum<V extends string>(...values: V[]): { [K in V]: K } {
    return values.reduce(
        (res, key) => {
            res[key] = key;
            return res;
        },
        {} as { [K in V]: K },
    );
}

export type createEnum<T extends string | Record<string, string>> =
    T extends Record<string, string> ? WithCreateEnumObject<T> : WithStringLiterals<T>;
/** @example createEnum<typeof enum> */
type WithCreateEnumObject<T extends Record<string, string>> =
    T extends Record<string, infer Value> ? Value : never;
/** @example createEnum<'apple' | 'banana' | 'kiwi'> */
type WithStringLiterals<T> = T;
